export default "__VITE_ASSET__BoJgoUQ6__"